module.exports = __webpack_public_path__ + "Simple-Line-Icons.dacd16c9a3d2cb61b472.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.eot?-i3a2kk
// module id = ../../../../../src/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.eot?-i3a2kk
// module chunks = styles